// extracted by mini-css-extract-plugin
module.exports = {"f1puhe4v":"f1puhe4v","fadeIn":"fadeIn","fadeIn-f1puhe4v":"fadeIn-f1puhe4v","fadeOut":"fadeOut","fadeOut-f1puhe4v":"fadeOut-f1puhe4v"};